import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Iframe from 'react-iframe';
import { obtenirProprietaire } from '../../../App_Code/API';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import * as ProAct from '../../../Actions/ProActions';

let urlYousign;

class PageSignerMandat extends Component {
    componentWillMount() {
        urlYousign = process.env.NODE_ENV === 'production' ? window.env.YOUSIGN_URL : process.env.REACT_APP_YOUSIGN_URL;

        if (this.props.location.state === undefined) {
            this.props.history.push('/MesInformations/SaisieRIB');
        } else {
            urlYousign += this.props.location.state;
        }
    }

    componentWillUnmount() {
        obtenirProprietaire().then((pro) => {
            this.props.actions.proAjout(pro);
        });
    }
    render() {
        return (
            <div>
                <Iframe
                    url={urlYousign}
                    width="100%"
                    height={window.screen.height - 300}
                />
            </div>
        );
    }
}
PageSignerMandat.displayName = 'PagSignerMandat';
PageSignerMandat.requiredProps = [];


function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(), mapDispatchToProps)(verificationProps(PageSignerMandat));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Prelevement/PageSignerMandat.js